import React, { useEffect, useState } from "react";
import { SupportItemModel } from "./SupportItemModel";

import "./SupportItem.css";
import { themeService } from "../../core/NotificationStripNav/ThemeService";
import { Theme } from "../../core/Models/CustomSiteConfigModel";
import Utils from "../../core/Utils/Utils";

interface SupportItemProps {
  blok: SupportItemModel;
  handleSupportItemClick?: () => void;
}
const SupportItem: React.FC<SupportItemProps> = ({
  blok,
  handleSupportItemClick,
}) => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());

  const handleSupportClick = () => {
    if (handleSupportItemClick) {
      handleSupportItemClick();
    }
  };

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  return (
    <div
      className="support-item"
      style={{
        backgroundColor: theme?.containerColor,
        color: theme?.textColor,
      }}
    >
      <div
        className="support-item-image"
        style={{ backgroundColor: blok.backgroundColor }}
      >
        <img
          src={Utils.getCacheUrl(blok.image?.filename)}
          alt=""
          onError={(e) => Utils.handleImageError(e, blok.image?.filename)}
        />
      </div>
      <div className="support-item-title">{blok.title}</div>
      <div className="support-item-description">{blok.description}</div>
      <div className="support-item-action">
        <span
          onClick={handleSupportClick}
          style={{ color: theme?.hyperlinksColor }}
        >
          Support
        </span>
      </div>
    </div>
  );
};

export default SupportItem;
